import { SFuncModal } from 'shj-components';
import { Form, message } from 'antd';
import { useRequest } from "ahooks";
import TextArea from 'antd/es/input/TextArea';
import { updateRemarkById } from '@/services/evaluateConfig';

export function addFn({ fn, ...rest }) {
    const onClose = () => {
        dialog.destroy();
    };
    const dialog = SFuncModal({
        title: '添加备注',
        width: 500,
        vanish: true,
        content: <ModalAddOrEditDom onClose={onClose} fn={fn} {...rest} />,
    });

    return dialog;
}

const ModalAddOrEditDom = ({ onClose, fn, ...rest }) => {
    const [form] = Form.useForm();
    let { loading: saveLoading, runAsync: runAsyncSave } = useRequest(updateRemarkById, { manual: true });

    // 提交
    const onFinish = () => {
        form.validateFields().then((values: any) => {
            runAsyncSave({ ...values, id: rest.id }).then((res: any) => {
                if (res) {
                    message.success('提交成功');
                    onClose();
                    fn && fn();
                } else {
                    message.error(res)
                    return
                }
            })
        })

    };

    const closeModal = () => {
        onClose();
    };
    return (
        <div>
            <SFuncModal.Content
                onCancel={closeModal}
                onOk={onFinish}
                confirmLoading={saveLoading}>
                <Form
                    layout="vertical"
                    form={form}>
                    <Form.Item
                        label="修改原因"
                        name="remark"
                        rules={[{ required: true, message: '请输入' }]}
                    >
                        <TextArea placeholder="请输入" rows={2} />
                    </Form.Item>
                </Form>
            </SFuncModal.Content>
        </div>
    );
};
